module.exports = __webpack_public_path__ + "static/somos-estrutura-e-parceria-8feaf3f6b777538c46e3f63e35e9fb68.png";